import { ReactNode } from 'react';
import styled from '@emotion/styled';

interface ItemCardBottomProps {
  children: ReactNode;
}

export const ItemCardBottom = ({ children }: ItemCardBottomProps) => {
  return <BottomSection>{children}</BottomSection>;
};

const BottomSection = styled.div`
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
